/* font-weight */
export const fontWeight = {
    /** font-weight: 400 */
    regular: '400',
    /** font-weight: 500 */
    medium: '500',
    /** font-weight: 700 */
    bold: '700',
};

/* font-size */
export const fontSize = {
    /** font-size: 8px */
    xxSmall: '0.5rem',
    /** font-size: 10px */
    xSmall: '0.625rem',
    /** font-size: 12px */
    small: '0.75rem',
    /** font-size: 14px */
    xRegular: '0.875rem',
    /** font-size: 16px */
    regular: '1rem',
    /** font-size: 18px */
    xxMedium: '1.125rem',
    /** font-size: 20px */
    xMedium: '1.25rem',
    /** font-size: 24px */
    medium: '1.5rem',
    /** font-size: 32px */
    big: '2rem',
    /** font-size: 48px */
    xxxBig: '3rem',
};
